import { CustomTheme } from '../../../lib/utils/CustomTheme';
export const stackStyle = { display: 'flex', flexDirection: 'column', gap: '2px' };
export const listStyle = {
    ul: {
        display: 'flex',
        flexDirection: 'column',
        listStyleType: 'none',
        padding: '0',
        margin: '0',
        gap: '1rem', // 16px to rem
        li: {
            lineHeight: '1.25rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem', // 2px to rem
            b: {
                fontFamily: 'Avenir-Black',
                '&.semi': {
                    fontFamily: 'Avenir',
                    fontWeight: 700,
                },
            },
            label: {
                color: CustomTheme.text.light,
            },
        },
    },
};
